import BriefcaseIcon from "@heroicons/react/24/solid/BriefcaseIcon";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../../assets/colors";
import { P } from "../styles";

export const JobTitleCard = styling("div")({
  backgroundColor: Color.white,
  border: `1px solid ${Color.grey}`,
  borderRadius: "0.5rem",

  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",

  padding: "1.5rem",

  "@media (max-width: 1279px)": {
    flexDirection: "column",
    gap: "1rem",
  },

  "@media (max-width: 640px)": {
    padding: "1rem",
  },
});

export const JobTitleContainer = styling("div")({
  display: "flex",
  flexDirection: "column",

  gap: "0.5rem",
});

export const CompanyDetailContainer = styling("div")({
  display: "flex",
  alignItems: "center",
  gap: "1rem",

  "@media (max-width: 640px)": {
    gap: "0.625rem",
  },
});

export const JobTitle = styling("h1")({
  color: Color.textHighEmphasis,

  fontSize: "1.5625rem",
  fontWeight: "700",
  lineHeight: "32px",

  margin: "0",

  "@media (max-width: 1279px)": {
    fontSize: "1.25rem",
    lineHeight: "24px",
  },

  "@media (max-width: 640px)": {
    fontSize: "1.0625rem",
    fontWeight: "600",
  },
});

export const CompanyName = styling("h2")({
  color: Color.hiredlyPurple,

  fontSize: "1rem",
  fontWeight: "400",
  lineHeight: "22px",

  textDecoration: "underline",
  textUnderlinePosition: "from-font",

  margin: "0",

  "@media (max-width: 640px)": {
    fontSize: "0.875rem",
    lineHeight: "24px",
    letterSpacing: "0.15px",
  },
});

export const JobCount = styling(P)({
  color: Color.hiredlyPurple,

  fontSize: "0.875rem",
  lineHeight: "24px",
  letterSpacing: "0.15px",
});

export const LinkStyled = styling("a")({
  textDecoration: "none",
  cursor: "pointer",
});

export const CompanyImage = styling("img")({
  backgroundImage: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  borderRadius: "0.5rem",

  width: "65px",
  height: "65px",
});

export const JobIcon = styling(BriefcaseIcon)({
  color: Color.hiredlyPurple,

  height: "16px",
  width: "16px",
});
